import {Flex, Text, Textarea} from '@chakra-ui/react';
import {AlertDialog} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC, useState} from 'react';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (text: string) => void;
}

export const AlertCanceledOrder: FC<IProps> = ({onClose, isOpen, onConfirm}) => {
  const {t} = useTranslation();
  const [text, setText] = useState('');
  const title = t('ORDER_CANCEL');
  const subTitle = t('ORDER_CANCEL_DESCRIPTION');

  const handleConfirm = () => {
    onConfirm(text);
    onClose();
  };

  return (
    <AlertDialog
      title={
        <Flex justifyContent="center" alignItems="center" flexDirection="column">
          <Text>{title}</Text>
          <Text fontWeight={500} textAlign="center">
            {subTitle}
          </Text>
        </Flex>
      }
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      successButtonValue={t('ORDER_CANCEL')}
      disabledSuccessButton={!text.length}
      reverseButtons
    >
      <Textarea value={text} onChange={(e) => setText(e.target.value)} />
    </AlertDialog>
  );
};
